<template>
  <div class='page-content'>
    <page-header>
      <template #breadcrumbs>
        Организации
      </template>
      <h2>Организации</h2>
      <template #actions>
        <div class='d-flex align-items-baseline actions'>
          <side-checkbox-component
              id='chbx_map'
              v-model='isShowMap'
              @change='loadPage'>
            Режим карты
          </side-checkbox-component>

          <side-checkbox-component
              id='chbx_organ'
              v-model='isShowOrgan'
              @change='changeShowOrgan'>
            Органы власти
          </side-checkbox-component>
          
          <button-component v-if="canAdd" @click='editCard(0)'>Создать</button-component>
          <button-component class="mx-2" v-if="canImportExcel" :disabled="importInProgress"
                            @click="importExcel()">
            <template v-if="!importInProgress">Загрузить из Excel</template>
            <template v-else>Загрузка...</template>
          </button-component>
          <button-component kind="tertiary" :class="{filtered: isFiltered}" @click="modals.filter = !modals.filter">
            <template #prepend>
              <icon-component class="mr-2" name="filter"/>
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>
    <section :class="{
      'content': !isShowMap
    }">
        <section class='modals'>
            <transition name='filter'>
                <div class='filter' :class="{'filter--filterMap': isShowMap}" v-if='modals.filter'>
                    <OrganizationsFilters
                        v-bind:filters='filters' v-bind:organ-mode='isShowOrgan'
                        v-on:apply='onFiltersApply($event)'
                        v-on:reset='onFiltersReset($event)'
                    />
                </div>
            </transition>
          <modal-component v-if="modals.importOrg" title="Импорт организаций" size-class=""
                           @close="modals.importOrg = false">
            <import-organization v-on:doimport="doImport" @close="modals.importOrg = false"/>
          </modal-component>
        </section>
      <template v-if='page.items'>
        <template v-if='!isShowMap'>
          <div  v-if='page.items.length'>
              <div class="table-inner">
            <table class='table-custom'>
              <thead>
              <tr>
                <th></th>
                <th class="col-table-1">Наименование полное</th>
                <th class="col-table-1">Наименование краткое</th>                
                <th class="col-table-2" v-if="isShowOrgan">Уровень управления</th>
                <th class="col-table-2">МР/ГО</th>
                <th class="col-table-3" v-if="isShowOrgan">Сфера управления	</th>
                <th class="col-table-3" v-else>Вид деятельности</th>
                <th class="col-table-4" v-if="!isShowOrgan">Форма собственности</th>
                <th class="col-table-5">Фактический адрес</th>
                <th class="col-table-6">ИНН</th>
                <th class="col-table-7">ОГРН</th>
                <th class="col-table-8" title='Деятельность прекращена' v-if="!isShowOrgan">Деят. прекр.</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for='item in page.items' :key="item.id"
                  v-on:dblclick="item.canEdit || canEdit ? editCard(item.id) : viewCard(item.id)">
                <td><menu-component class="actions" :actions="actions(item)" /></td>
                <td>{{ item.nameFull }}</td>
                <td>{{ item.name }}</td>                
                <td v-if="isShowOrgan">{{ !item.districtName ? "региональный" : "муниципальный" }}</td>
                <td>{{ item.districtName }}</td>
                <td>{{ item.kindActivityName }}</td>
                <td v-if="!isShowOrgan">{{ item.opfName }}</td>
                <td>{{ item.address }}</td>
                <td>{{ item.inn }}</td>
                <td>{{ item.ogrn }}</td>
                <td class="td-center" v-if="!isShowOrgan">
                  <checkbox :id="'isactive_' + item.id" v-bind:modelValue="!item.isActive" :disabled="true"/>
                </td>
              </tr>
              </tbody>
            </table>
              </div>
            <div v-if='page.pagesTotal > 1'>
              <Pagination
                  :page-count='page.pagesTotal'
                  :current-page='page.pageNumber'
                  @change='onPageChange($event)'
              />
            </div>
            <div>
              <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
            </div>
          </div>
          <div v-else>
            <EmptyListMessage/>
          </div>
        </template>
      </template>
    </section>
    <section v-if='isShowMap' class='map-container d-flex flex-grow-1'>
      <!-- leaflet map -->
      <l-map
          class='map h-auto'
          ref='myMap'
          :zoom='8'
          :center='[56.3, 44.01]'
      >
        <l-tile-layer
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        ></l-tile-layer>
        <l-marker v-for='(item, index) in page.items' :key='index' :lat-lng='item'  :icon="getMarkerIcon(item.kindActivityId)">
          <l-popup>
            <router-link :to="{ name: isShowOrgan ? 'cardOrganVlasti' : 'cardOrganization', params: { id: item.id, action: 'view' } }">
              {{ item.nameFull }}
            </router-link>
            <div>{{ item.kindActivityName }}</div>
            <div>{{ item.address }}</div>
          </l-popup>
        </l-marker>
      </l-map>
    </section>
  </div>
</template>

<script>
  import API from '../api/organizations'
  import OrganizationsFilters from '../components/OrganizationsFilter.vue'
  import 'leaflet/dist/leaflet.css'
  import { LMap, LMarker, LPopup, LTileLayer } from '@vue-leaflet/vue-leaflet'
  import Constants from '../../../common/constants'
  import ButtonComponent from '@/common/ui/ButtonComponent'
  import PageHeader from '@/common/components/page/PageHeader'
  import IconComponent from '@/common/ui/IconComponent'
  import EmptyListMessage from "../../../common/components/EmptyListMessage";
  import Utils from "../../../common/utils";
  import SideCheckboxComponent from "@/common/ui/sideCheckboxComponent";
  import Checkbox from "@/common/ui/checkbox";
  import security from "../../../common/mixins/security";
  import MenuComponent from "@/common/ui/components/page/MenuComponent";
  import filtermanager from "../../../common/mixins/filtermanager";
  import ModalComponent from "../../../common/ui/ModalComponent";
  import ImportOrganization from "../components/ImportOrganization";
  import userManager from "../../auth/user-manager";
  import PageCounter from "@/common/components/PageCounter";

  export default {
    name: 'Organizations',
    components: {
      ImportOrganization,
      ModalComponent,
      MenuComponent,
      Checkbox,
      SideCheckboxComponent,
      EmptyListMessage,
      IconComponent,
      PageHeader,
      ButtonComponent,
      OrganizationsFilters,
      LMap,
      LMarker,
      LTileLayer,
      LPopup,
      PageCounter
    },
    mixins: [security, filtermanager],
    created() {
      //загрузить по-умолчанию
      this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
      //console.log(this.$route.params);
      this.checkPermission(Constants.OrganizationEdit).then((response) => {
        this.canOrganizationEdit = response.data;
      });
      this.checkPermission(Constants.OrganVlastiEdit).then((response) => {
        this.canOrganVlastiEdit = response.data;
      });
      userManager.getUser().then((user) => {
        this.canImportExcel = user.profile.role.indexOf(Constants.AdminRoleId) > -1;
      });
      this.getTotalCount();
      this.loadPage();
    },
    data() {
      return {
        isShowMap: false,
        isShowOrgan: !!(this.$route.params && this.$route.params.isOrgan),
        map: null,
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filters: {
          districtType: 0,
          districtIds: [],
          serviceTypeId: 0,
          kindActivityId: 0,
          name: '',
          ogrn: '',
          dateRegistration: null,
          dateLastChange: null,
          opfIds: [],
          inn: '',
          organizationTypeId: 0,
          organizationSubtypeId: 0,
        },
        page: {},
        modals: {
          filter: false,
          importOrg: false
        },
        canOrganizationEdit: true,
        canOrganVlastiEdit: true,
        isFiltered: false,
        canImportExcel: false,
        importInProgress: false
      }
    },
    computed: {
      canAdd() {
        return this.isShowOrgan ? this.canOrganVlastiEdit : this.canOrganizationEdit;
      },
    },
    methods: {
      getTotalCount() {
        const self = this;
        API.search({ pageNumber: 1, pageSize: 1}).then(function (response) {
          self.totalCount = response.data.itemsTotal;
        });
      },
      actions(item){
        let result = [{
          title: 'Просмотр',
          icon: 'eye',
          click: () =>  this.viewCard(item.id)
        }];
        if(this.isShowOrgan) {
          if (this.canOrganVlastiEdit || item.canEdit) {
            result.push({
              title: 'Редактировать',
              icon: 'pen',
              click: () => this.editCard(item.id)
            });
          }
          if(this.canOrganVlastiEdit) {
            result.push({
              title: 'Удалить',
              icon: 'trash',
              click: () => this.deleteCard(item.id)
            });
          }
        } else {
          if (this.canOrganizationEdit || item.canEdit) {
            result.push({
              title: 'Редактировать',
              icon: 'pen',
              click: () => this.editCard(item.id)
            });
          }
          if(this.canOrganizationEdit) {
            result.push({
              title: 'Удалить',
              icon: 'trash',
              click: () => this.deleteCard(item.id)
            });
          }
        }
        
        return result;
      },
      getMarkerIcon(kindActivityId) {
        return Utils.getMarkerIcon(kindActivityId, false);
      },
      onPageChange(pageNumber) {
        this.request.pageNumber = pageNumber;
        this.$router.push({
          query: {
              ...this.$route.query,
              page: pageNumber
            }
        });
        this.loadPage();
      },
      changeShowOrgan() {
        //когда переключатель меняем, то надо страницу сбросить на первую
        if(this.request.pageNumber == 1)
          this.loadPage();
        else
          this.onPageChange(1);
      },
      loadPage() {
        const filter = this.loadFilter();
        if (filter) {
          this.filters = filter;
          this.isFiltered = true;
        }
        var params = Object.assign(Object.assign(this.filters, this.request), {
          isShowMap: this.isShowMap,
          isOrgan: this.isShowOrgan
        });
        API.search(params).then((response) => {
          this.page = {};
          this.$nextTick(() => {
            this.page = response.data;
          });
        });
      },
      viewCard(id) {
        var name = this.isShowOrgan ? 'cardOrganVlasti' : 'cardOrganization';
        this.$router.push({ name: name, params: { id: id, action: 'view' }, query: { page: this.request.pageNumber } })
      },
      editCard(id) {
        var name = this.isShowOrgan ? 'cardOrganVlasti' : 'cardOrganization';
        this.$router.push({ name: name, params: { id: id, action: 'edit' }, query: { page: this.request.pageNumber } })
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id).then((response) => {
              Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error')
              if (response.data.success) {
                this.getTotalCount();
                this.loadPage();
              }
            })
          }
        })
      },
      importExcel() {
        this.modals.importOrg = true;
      },
      doImport(file) {
        this.modals.importOrg = false;
        this.importInProgress = true;
        API.importExcel(this.name, file)
            .then((response) => {
              if (response.data.success) {
                Constants.alert.fire('Импорт', response.data.message, 'success');
              } else {
                Constants.alert.fire('Импорт', response.data.message, 'error');
              }
              this.loadPage();
              this.importInProgress = false;
            })
            .catch((response) => {
              console.log(response);
              Constants.alert.fire('Импорт', 'Ошибка при импорте организаций.', 'error');
              this.importInProgress = false;
            });
      },
      onFiltersApply(filters) {
        this.filters = filters;
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.saveFilter(this.filters);
        this.isFiltered = true;
        this.loadPage();
      },
      onFiltersReset(filters) {
        this.filters = filters || {};
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.removeFilter();
        this.isFiltered = false;
        this.loadPage();
      }
    },
  watch: {
    '$route.query.page': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@import '/src/assets/theme/default/colors.scss';

.page-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity .2s;
    z-index: 1000;
    &--filterMap{
        top: 212px;
        overflow: auto;
        max-height: 65vh;
    }
}
.content {
  padding: 16px 16px 0 16px;
  position: relative;
  height: auto;




  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

}

.col-table {
  &-1 {
    min-width: 200px;
    max-width: 200px;
  }

  &-2 {
    min-width: 145px;
    max-width: 145px;
  }

  &-3 {
    min-width: 175px;
    max-width: 175px;
  }

  &-4, &-5 {
    min-width: 170px;
    max-width: 170px;
  }

  &-6 {
    min-width: 96px;
    max-width: 96px;
  }

  &-7, &-8 {
    min-width: 142px;
    max-width: 142px;
  }

  &-9 {
    min-width: 65px;
    max-width: 65px;
  }

  &-10 {
    min-width: 72px;
    max-width: 72px;
  }

  &-11 {
    min-width: 110px;
    max-width: 110px;
  }

  &-12 {
    min-width: 125px;
    max-width: 125px;
  }
}

.fa-eye, .fa-pen, .fa-trash-alt {
  color: $gray-medium
}

.td-center {
  text-align: center;
}

.map-filter-component {
  padding: 14px 32px;
}
  .filtered {
    color: $red;
    &:hover {
      color: $red-dark;
    }
  }
</style>